<ng-container
  *ngLet="{
    filterable: defaultedFilterable | async,
    disabled: defaultedDisabled | async,
    exact: defaultedExact | async,
    options: defaultedOptions | async,
    nodes: nodes | async,
    allNodes: allNodes | async,
    loadable: optionsLoadable | async,
    notShownCount: notShownCount | async,
    filterPositionBottom: defaultedFilterPositionBottom | async,
    filter: filter | async,
    multiSelect: defaultedMultiSelect | async,
    atMinSelected: atMinSelected | async,
    atMaxSelected: atMaxSelected | async,
    currentTab: currentTab | async,
    subs: subs | async,
    selectedNodes: selectedNodes | async
  } as vm"
>
  <tab-set *ngIf="tabNames && tabNames.length > 0">
    <ng-container *ngFor="let tabName of tabNames">
      <a
        tab
        rivetLink
        [activeClass]="tabName === vm.currentTab"
        (click)="tabChange.emit(tabName)"
      >
        {{ tabName }}
      </a>
    </ng-container>
  </tab-set>
  <option-filter
    class="rv-rows rv-grow"
    *ngIf="vm.filterable"
    [autoFocus]="true"
    [disabled]="vm.disabled"
    [filterEmpty]="
      !!vm.filter && !vm.loadable?.loading && (!vm.nodes || !vm.nodes.length)
    "
    [filter]="vm.filter"
    [inputPositionBottom]="vm.filterPositionBottom"
    (filterChange)="filter.next($event); filterChange.emit($event)"
  >
    <ng-container *ngTemplateOutlet="selectedTemplate"> </ng-container>
    <loadable [data]="vm.loadable" class="rv-rows rv-grow options">
      <ng-container *ngTemplateOutlet="selectedNodesTemplate"> </ng-container>
      <ng-container
        *ngTemplateOutlet="
          nodesTemplate;
          context: { $implicit: showAllNodes ? vm.allNodes : vm.nodes }
        "
      ></ng-container>
    </loadable>
  </option-filter>
  <ng-container *ngIf="!vm.filterable">
    <ng-container *ngTemplateOutlet="selectedTemplate"> </ng-container>
    <loadable [data]="vm.loadable" class="rv-rows rv-grow options">
      <ng-container *ngTemplateOutlet="selectedNodesTemplate"> </ng-container>
      <ng-container
        *ngTemplateOutlet="
          nodesTemplate;
          context: { $implicit: showAllNodes ? vm.allNodes : vm.nodes }
        "
      ></ng-container>
    </loadable>
  </ng-container>
  <ng-template #nodesTemplate let-nodes>
    <div
      class="options-inner"
      #dragBoundary
      [style.minWidth.px]="draggable ? minWidth : 0"
    >
      <ng-container *ngIf="nodeDirective">
        <ng-container
          #nodeRef
          *ngFor="let node of nodes; let i = index; trackBy: trackBy"
        >
          <ng-container
            *ngTemplateOutlet="
              nodeDirective.template;
              context: { $implicit: node, selectionHandler: this }
            "
          ></ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!nodeDirective">
        <div
          cdkDropList
          (cdkDropListDropped)="handleDrop($event)"
          class="option-list"
        >
          <option-select-node
            class="option-node"
            #nodeRef
            *ngFor="let node of nodes; let i = index; trackBy: trackBy"
            [disabled]="vm.disabled || (vm.atMaxSelected && !node.selected)"
            [displayId]="displayId"
            [node]="node"
            [pinned]="getPinned(i)"
            [multiSelect]="vm.multiSelect"
            [atMinSelected]="vm.atMinSelected"
            (selected)="onNodeSelected(node.id)"
            (isPinned)="onNodePinned(node.id)"
            (isUnpinned)="onNodeUnpinned(node.id)"
            (unselected)="onNodeUnselected(node.id)"
            (dragWidth)="setMinWidth($event)"
            [showAvatars]="showAvatars"
            [all]="all"
            [draggable]="draggable"
            [actionButton]="optionActionButton"
          >
          </option-select-node>
        </div>
      </ng-container>
      <div
        class="more rv-link"
        *ngIf="vm.notShownCount > 0 && !showAllNodes"
        (click)="showMore()"
      >
        {{ usingLoader ? 'Show' : vm.notShownCount }} more...
      </div>
    </div>
  </ng-template>
  <ng-template #nodesSelectedTemplate let-nodes>
    <div class="options-inner">
      <option-select-node
        #nodeRef
        *ngFor="let node of nodes; let i = index; trackBy: trackBy"
        [disabled]="vm.disabled || (vm.atMaxSelected && !node.selected)"
        [displayId]="displayId"
        [node]="node"
        [pinned]="getPinned(i)"
        [multiSelect]="vm.multiSelect"
        [atMinSelected]="vm.atMinSelected"
        (unselected)="onNodeUnselectedNoScroll(node.id, vm.nodes[0])"
        [all]="all"
      ></option-select-node>
    </div>
  </ng-template>
  <ng-template #selectedTemplate>
    <div
      class="rv-flex show-selected-row"
      (click)="showSelected = !showSelected"
      *ngIf="selectedEnabled"
    >
      <div>Selected</div>
      <div class="rv-flex show-selected-arrow">
        <span>
          {{ all ? vm.options.length : vm.selectedNodes?.length || '0' }}
        </span>
        <riv-icon
          [name]="showSelected ? 'ChevronUp' : 'ChevronDown'"
        ></riv-icon>
      </div>
    </div>
  </ng-template>
  <ng-template #selectedNodesTemplate>
    <ng-container *ngIf="selectedEnabled">
      <div class="selected-nodes">
        <ng-container *ngIf="showSelected">
          <ng-container
            *ngTemplateOutlet="
              nodesSelectedTemplate;
              context: { $implicit: vm.selectedNodes }
            "
          ></ng-container>
        </ng-container>
      </div>
    </ng-container>
  </ng-template>
</ng-container>
